import { useEffect, useState } from "react";
import MobileMenuContent from "./MobileMenuContent";
import SavedPreference from "./save-preference";
import SearchBar from "./SearchBar";
import { useLocation } from "react-router";
import logo from '../../../../public/assets/images/logo-mob.svg';
import useWindowDimensions from "@/hooks/useWindowDimensions";

const MobileMenu = ({ hasBanner = false }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const {pathname} = useLocation();
  const { width } = useWindowDimensions();
  const isHomePage = pathname === "/";

  // Function to handle sidebar open/close
  useEffect(() => {
    const offcanvasElement = document.getElementById("ss");

    const handleOpen = () => setIsSidebarOpen(true);
    const handleClose = () => setIsSidebarOpen(false);

    offcanvasElement?.addEventListener("shown.bs.offcanvas", handleOpen);
    offcanvasElement?.addEventListener("hidden.bs.offcanvas", handleClose);

    // Cleanup event listeners when the component is unmounted
    return () => {
      offcanvasElement?.removeEventListener("shown.bs.offcanvas", handleOpen);
      offcanvasElement?.removeEventListener("hidden.bs.offcanvas", handleClose);
    };
  }, []);

  const handleShowNavbar = () => {
    if (window.scrollY >= 400) {
      setShowSearch(true);
    } else {
      setShowSearch(false);
    }
  };
  useEffect(() => {
    isHomePage && window.addEventListener("scroll", handleShowNavbar);
    return () => {
      isHomePage && window.removeEventListener("scroll", handleShowNavbar);
    }
  }, [isHomePage]);
  if (width <= 991) {
    return (
      // <!-- Main Header Nav For Mobile -->
      <div className="stylehome1 h0 mega-menu-wrapper pb85">
        <div className="mobile-menu" style={{ top: hasBanner ? '40px' : '0px' }}>
          <div className="header stylehome1">
            {/* main_logo_home2 */}

            <ul className="menu_bar_home2">
              <li className="list-inline-item">
                {" "}
              </li>
              <li className={`list-inline-item ${((isHomePage && showSearch) || !isHomePage)?"home-mob-logo":"home-mob-logo1"}`}>
                <img
                  className="nav_logo_img contain mt20"
                  src={((isHomePage && showSearch) || !isHomePage) ?logo:"/assets/images/hubzu-logo.png"}
                  alt="hubzu-logo.png"
                  onClick={() => window.open('/', "_self")}
                />
              </li>
              <li className="list-inline-item home-mob-search">
                {((isHomePage && showSearch) || !isHomePage) && <SearchBar />}
              </li>
              <li
                className="list-inline-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasMenu"
                aria-controls="offcanvasMenu"
              >
                <a className="home-mob-menu" href="#">
                  <span></span>
                </a>
              </li>
            </ul>
            {/* menu_bar_home2 */}
          </div>
        </div>
        {/* <!-- /.mobile-menu --> */}

        <div
          className="offcanvas offcanvas-start"
          tabIndex="-1"
          id="offcanvasMenu"
          data-bs-scroll="true"
        >
          <MobileMenuContent />
        </div>
        <div
          className="offcanvas offcanvas-end offcanvas-listing-sidebar"
          tabIndex="-1"
          id="ss"
        >
          {isSidebarOpen && <SavedPreference />}
        </div>
      </div>
    );
  } else {
    return <div/>;
  }
};

export default MobileMenu;
